<div align="right">
  <button  mat-raised-button color="accent" (click)="logout()">
    <mat-icon>logout</mat-icon>
    </button>
</div>


<ul class="nav nav-tabs">
  <li class="nav-item">
    <a class="nav-link " aria-current="page" href="../registroprofesores">Registro Profesores</a>

  </li>
  <li class="nav-item">
    <a class="nav-link " aria-current="page" href="../crud-usuario"> Usuario</a>
  </li>
  <li class="nav-item">
    <a class="nav-link " aria-current="page" href="../crear-encuesta">Crear Encuestas</a>
  </li>
  <li class="nav-item">
    <a class="nav-link " aria-current="page" href="../menuReporte">Reportería</a>
  </li>

</ul>


<h3  align="center">Usuarios</h3>


<br /><br />

<div class="container">
  <div class="row">
    <div class="col-12">
      <div class="form-group">
        <input type="text" class="form-control" name="filterPost" placeholder="Buscar carnet.." [(ngModel)]="filterPost">
      </div>
      <div class="table-responsive">
        <table class="table table-striped">
          <thead class="thead-light">
            <tr >
              <th scope="col">No.</th>
              <th scope="col">Carnet</th>
              <th scope="col">Nombres</th>
              <th scope="col">Apellidos</th>
              <th scope="col">Correo</th>
              <th scope="col">Rol</th>
              <th scope="col">Estado</th>
              <th scope="col">Reseteo</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody >
           <tr *ngFor="let user of listado | filter:filterPost let i = index" >
              <th *ngIf="i<15" scope="row">{{ i+1 }}</th>
              <td *ngIf="i<15">{{ user.carnet }}</td>
              <td *ngIf="i<15">{{ user.nombres }}</td>
              <td *ngIf="i<15">{{ user.apellidos }}</td>
              <td *ngIf="i<15">{{ user.correo }}</td>
              <td *ngIf="i<15">{{user.idRol }}</td>
              <td *ngIf="i<15"> <mat-slide-toggle color="primary" [ngModel]="user.estado" [checked]="user.estado" (change)="toggle($event,user)" ></mat-slide-toggle></td>
              <td *ngIf="i<15"> <button  (click)="reseteo(user.carnet)">Resetear contraseña</button> </td>
            </tr>
         </tbody>
        </table>
       </div>
    </div>

  </div>
</div>


